import { render } from "./SuccessAnimation.vue?vue&type=template&id=fae4039e&scoped=true"
import script from "./SuccessAnimation.vue?vue&type=script&lang=js"
export * from "./SuccessAnimation.vue?vue&type=script&lang=js"

import "./SuccessAnimation.vue?vue&type=style&index=0&id=fae4039e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fae4039e"]])

export default __exports__